module.exports = __webpack_public_path__ + "media/images/keys-f1f5f0883115f936c5896360a5707b44.png";